import React from 'react'

import { useQuery } from '@tanstack/react-query'
import { Alert } from '@vtex/shoreline'

import { ButtonNavLink } from '~/components/Buttons'
import { useAPPTranslation } from '~/i18n/useAPPTranslation'
import { listAdvertisersService } from '~/modules/retailMedia/services/advertiser-publisher'

// import { Container } from './styles';

type AlertDuplicatedProps = {
  field: 'advertiser_name' | 'seller_id'
  value: string
}

const AlertDuplicated: React.FC<AlertDuplicatedProps> = ({ field, value }) => {
  const { t } = useAPPTranslation()
  const {
    isPending,
    data: response,
    error
  } = useQuery({
    enabled: !!value,
    queryKey: ['checkDuplicatedAdvertiser', field, value],
    queryFn: async () => {
      const payload = {
        [field]: value
      }

      const response = await listAdvertisersService(payload)

      return response.data
    }
  })

  const content = {
    advertiser_name: {
      text: (
        <>
          O <strong>nome de anunciante</strong>, ou parte dele, está sendo usado
          por outra conta. Verifique se o anunciante já está cadastrado.
        </>
      )
    },
    seller_id: {
      text: (
        <>
          Esse <strong>seller id</strong> já foi usado em outra conta de
          anunciante. Verifique se o anunciante já está cadastrado.
        </>
      )
    }
  }

  return (
    !!response?.total && (
      <Alert variant="warning" className="mt-2">
        {content[field].text}
        <ButtonNavLink
          to={`/retail-media/config/advertisers?${field}=${value}`}
          target="_blank"
          template="tertiary"
        >
          Verificar
        </ButtonNavLink>
      </Alert>
    )
  )
}

export default AlertDuplicated
